'use strict';
import config from './config';
import $ from 'jquery';

const auth = {
    login: function (username, pass, cb) {
        this.logout();
        // Todo: handle the expiration of the tokens
        //if (localStorage.token) {
        //    if (cb) cb(true);
        //    return
        //}
        this.getToken(username, pass, (res) => {
            if (res.authenticated) {
                localStorage.token = res.token;
                if (cb) { cb(true); }
            } else {
                if (cb) { cb(false, res.error); }
            }
        });
    },

    logout: function () {
        delete localStorage.token;
    },

    loggedIn: function () {
        return !!localStorage.token;
    },

    token: function() {
        return localStorage.token;
    },

    getToken: function (username, password, cb) {
        var url = config.backend_url + '/accounts/token-auth/';
        $.ajax({
            url: url,
            data: {
                email: username,
                password: password
            },
            dataType: 'json',
            crossDomain: true,
            method: 'POST',
            success: function (res) {
                cb({
                    authenticated: true,
                    token: res.access
                });
            },
            error: function (res) {
                cb({
                    authenticated: false,
                    error: res.responseJSON
                });
            }
        });
    }
};

export default auth;
